// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon_2Ki95","carousel":"index_carousel_2NKyU"};